module.exports = __webpack_public_path__ + "static/media/logocolor_roundcorners.f4dd179b.svg";